import { BnplBand } from "@/components/marketplace/bnpl/bnpl-band"

// The listing surfaces auto-load up to eight pages, so the ClaimBand in the
// chrome sits past 10,000px and is never reached — measured 2026-08-01 on
// /mx/busqueda. The offer has to be inside the results column instead.
export const ListingBnplBand = ({ className }: { className?: string }) => <BnplBand containment="inset" className={className} />
